import React from 'react';

/**
 * Small coloured badge for a member's status label, as computed server-side
 * in affiliate.controller.js's computeMemberStatus (active / inactive /
 * free_trial / free_until). Label text comes from the server — this just
 * picks the colour for whichever status it's tagged with.
 */
const STATUS_CLASSES = {
  active: 'bg-reset-sage/15 text-reset-sage',
  inactive: 'bg-gray-100 text-gray-500',
  free_trial: 'bg-reset-gold/25 text-reset-brown',
  free_until: 'bg-reset-terracotta/15 text-reset-terracotta',
};

export default function MemberStatusBadge({ status, label }) {
  if (!label) return null;
  const classes = STATUS_CLASSES[status] || 'bg-gray-100 text-gray-500';
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${classes}`}>
      {label}
    </span>
  );
}
